// extracted by mini-css-extract-plugin
module.exports =  {"root":"swAIQAvRVzALx0t6O2t1"};